import React from 'react';

import { IBrandContext } from './common/brands';

const BrandContext = React.createContext({} as IBrandContext);

export const BrandContextProvider = BrandContext.Provider;

export default BrandContext;
